import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { withStyles, makeStyles } from '@material-ui/core/styles'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Button from '@material-ui/core/Button'
import ArrowRightOutlinedIcon from '@material-ui/icons/ArrowRightOutlined'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ReplayIcon from '@material-ui/icons/Replay'
import Slider from '@material-ui/core/Slider'
import OfflineBoltIcon from '@material-ui/icons/OfflineBolt'
import Grow from '@material-ui/core/Grow'
import Modal from '@material-ui/core/Modal'
import Checkbox from '@material-ui/core/Checkbox'
import Tooltip from '@material-ui/core/Tooltip'

import ToggleOffOutlinedIcon from '@material-ui/icons/ToggleOffOutlined'
import ToggleOnOutlinedIcon from '@material-ui/icons/ToggleOnOutlined'
import WbSunnyIcon from '@material-ui/icons/WbSunny'
import AcUnitIcon from '@material-ui/icons/AcUnit'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import PowerIcon from '@material-ui/icons/Power'

// import { setLayersInfo } from 'store/global/map/layersInfo'
import { setSideBarInfo } from 'store/global/map/sideBarInfo'

import { SeasonSlider } from './season'
import InfoWindow from '../Infraestructure/info.js'
// import { WinterSlider } from './winter'

import './Interconnection.css'

const useStyles = makeStyles({
  root: {
    width: 150,
    color: '#c2c6cc',
    marginLeft: '20px',
  },
  btn: {
    boxShadow: 'none',
    color: '#a65e44',
    borderColor: '#a65e44',
    '&:hover': {
      backgroundColor: '#a65e441A',
      borderColor: '#a65e44',
      boxShadow: 'none',
    },
  },
})

function Interconnections(props) {
  const dispatch = useDispatch()

  const [sliderValueWinter, setSliderValueWinter] = useState([0, 1000])
  const [sliderValueSummer, setSliderValueSummer] = useState([0, 1000])
  const [sliderValueSummerCol, setSliderValueSummerCol] = useState([0, 300])
  const [sliderValueLines, setSliderValueLines] = useState([0, 1000])
  const [maxSliderValue, setMaxSliderValue] = useState(3000)
  const [resetMax, setResetMax] = useState(1000)
  // const [sliderValues, setSliderValues] = useState([])
  // const [sliderScale, setSliderScale] = useState([])

  const classes = useStyles()

  // useEffect(() => {
  //   props.conLayers.map(obj =>{
  //     var values=sliderValues
  //     values.push({[obj.name]:[0, 1000]})
  //     setSliderValues(values)
  //   })

  //   console.log(sliderValues)
  // }, [])

  useEffect(() => {
    if (props.country === 'Colombia') {
      setSliderValueSummer([0, 300])
      setSliderValueWinter([0, 300])
      setMaxSliderValue(1000)
      setResetMax(300)
    }
  }, [])

  const sliderWinter = (event, newValue) => {
    setSliderValueWinter(newValue)
  }

  const sliderSummer = (event, newValue) => {
    setSliderValueSummer(newValue)
    setSliderValueSummerCol(newValue)
  }

  const sliderLines = (event, newValue) => {
    setSliderValueLines(newValue)
  }

  const linesHeatmap = (min, max) => {
    const item = [...props.layerData]
    const dif = (max - min) / 5
    const colorScale = [
      [255, 0, 0],
      [255, 94, 0],
      [255, 162, 0],
      [255, 230, 0],
      [225, 255, 0],
      [174, 255, 0],
      [0, 255, 0],
    ]
    const busNum = [[min], [min + dif], [min + dif * 2], [min + dif * 3], [min + dif * 4], [max]]
    const filter = item.filter((obj) => obj.layer == 'tranline_ic')
    // console.log(filter)
    filter
      .filter((obj) => obj.id == 'tranline_con_400')[0]
      .data.map((obj) => {
        if (obj.thermal_limit_int <= min) obj.specificDesign.color = colorScale[0]
        if (obj.thermal_limit_int > min && obj.thermal_limit_int <= busNum[1]) obj.specificDesign.color = colorScale[1]
        if (obj.thermal_limit_int > busNum[1] && obj.thermal_limit_int <= busNum[2])
          obj.specificDesign.color = colorScale[2]
        if (obj.thermal_limit_int > busNum[2] && obj.thermal_limit_int <= busNum[3])
          obj.specificDesign.color = colorScale[3]
        if (obj.thermal_limit_int > busNum[3] && obj.thermal_limit_int <= busNum[4])
          obj.specificDesign.color = colorScale[4]
        if (obj.thermal_limit_int > busNum[4] && obj.thermal_limit_int <= busNum[5])
          obj.specificDesign.color = colorScale[5]
        if (obj.thermal_limit_int >= busNum[5]) obj.specificDesign.color = colorScale[6]
      })

    filter
      .filter((obj) => obj.id == 'tranline_con_230')[0]
      .data.map((obj) => {
        if (obj.thermal_limit_int <= min) obj.specificDesign.color = colorScale[0]
        if (obj.thermal_limit_int > min && obj.thermal_limit_int <= busNum[1]) obj.specificDesign.color = colorScale[1]
        if (obj.thermal_limit_int > busNum[1] && obj.thermal_limit_int <= busNum[2])
          obj.specificDesign.color = colorScale[2]
        if (obj.thermal_limit_int > busNum[2] && obj.thermal_limit_int <= busNum[3])
          obj.specificDesign.color = colorScale[3]
        if (obj.thermal_limit_int > busNum[3] && obj.thermal_limit_int <= busNum[4])
          obj.specificDesign.color = colorScale[4]
        if (obj.thermal_limit_int > busNum[4] && obj.thermal_limit_int <= busNum[5])
          obj.specificDesign.color = colorScale[5]
        if (obj.thermal_limit_int >= busNum[5]) obj.specificDesign.color = colorScale[6]
      })

    filter
      .filter((obj) => obj.id == 'tranline_con_115')[0]
      .data.map((obj) => {
        if (obj.thermal_limit_int <= min) obj.specificDesign.color = colorScale[0]
        if (obj.thermal_limit_int > min && obj.thermal_limit_int <= busNum[1]) obj.specificDesign.color = colorScale[1]
        if (obj.thermal_limit_int > busNum[1] && obj.thermal_limit_int <= busNum[2])
          obj.specificDesign.color = colorScale[2]
        if (obj.thermal_limit_int > busNum[2] && obj.thermal_limit_int <= busNum[3])
          obj.specificDesign.color = colorScale[3]
        if (obj.thermal_limit_int > busNum[3] && obj.thermal_limit_int <= busNum[4])
          obj.specificDesign.color = colorScale[4]
        if (obj.thermal_limit_int > busNum[4] && obj.thermal_limit_int <= busNum[5])
          obj.specificDesign.color = colorScale[5]
        if (obj.thermal_limit_int >= busNum[5]) obj.specificDesign.color = colorScale[6]
      })

    item.find((obj) => obj.id === 'tranline_con_400').data = filter.filter(
      (obj) => obj.id == 'tranline_con_400',
    )[0].data
    item.find((obj) => obj.id === 'tranline_con_230').data = filter.filter(
      (obj) => obj.id == 'tranline_con_230',
    )[0].data
    item.find((obj) => obj.id === 'tranline_con_115').data = filter.filter(
      (obj) => obj.id == 'tranline_con_115',
    )[0].data

    item.find((obj) => obj.id === 'tranline_con_400').design.color = [255, 255, 255 * Math.random()]
    item.find((obj) => obj.id === 'tranline_con_230').design.color = [255, 255, 255 * Math.random()]
    item.find((obj) => obj.id === 'tranline_con_115').design.color = [255, 255, 255 * Math.random()]

    props.setLayerData(item)

    // let currentLayersInfoStoredJSON = JSON.parse(JSON.stringify(props.layerData))
    // let currentLayersInfo = [...currentLayersInfoStoredJSON]
    // dispatch( setLayersInfo( currentLayersInfo))
  }

  const generalHeatmap = (min, max, id) => {
    // console.log(id)
    const item = [...props.layerData]
    const dif = (max - min) / 6
    const colorScale = [
      [255, 0, 0],
      [255, 94, 0],
      [255, 162, 0],
      [255, 230, 0],
      [225, 255, 0],
      [174, 255, 0],
      [0, 255, 0],
    ]
    const busNum = [[min], [min + dif], [min + dif * 2], [min + dif * 3], [min + dif * 4], [min + dif * 5], [max]]
    // console.log(min + '-' + max)
    const layerData = item.filter((obj) => obj.layer == id[0].section)

    id.map((val) => {
      // console.log(layerData.find((obj) => obj.id == val.id))
      layerData
        .find((obj) => obj.id == val.id)
        .data.map((obj) => {
          if (!obj.heatmap && obj.heatmap == null) obj.specificDesign.color = [255, 255, 255, 20]
          if (obj.heatmap && obj.heatmap <= min) obj.specificDesign.color = colorScale[0]
          if (obj.heatmap && obj.heatmap > min && obj.heatmap <= busNum[1]) obj.specificDesign.color = colorScale[1]
          if (obj.heatmap && obj.heatmap > busNum[1] && obj.heatmap <= busNum[2])
            obj.specificDesign.color = colorScale[2]
          if (obj.heatmap && obj.heatmap > busNum[2] && obj.heatmap <= busNum[3])
            obj.specificDesign.color = colorScale[3]
          if (obj.heatmap && obj.heatmap > busNum[3] && obj.heatmap <= busNum[4])
            obj.specificDesign.color = colorScale[4]
          if (obj.heatmap && obj.heatmap > busNum[4] && obj.heatmap <= busNum[5])
            obj.specificDesign.color = colorScale[5]
          if (obj.heatmap && obj.heatmap >= busNum[5]) obj.specificDesign.color = colorScale[6]
        })
    })

    id.map((val) => {
      item.find((obj) => obj.id === val.id).data = layerData.find((obj) => obj.id == val.id).data
      item.find((obj) => obj.id === val.id).design.color = [255, 255, 255 * Math.random()]
    })

    props.setLayerData(item)

    // let currentLayersInfoStoredJSON = JSON.parse(JSON.stringify(props.layerData))
    // let currentLayersInfo = [...currentLayersInfoStoredJSON]
    // dispatch( setLayersInfo( currentLayersInfo))
  }

  const summerHeatmapCol = (min, max) => {
    const item = [...props.layerData]
    const dif = (max - min) / 6
    const colorScale = [
      [255, 0, 0],
      [255, 94, 0],
      [255, 162, 0],
      [255, 230, 0],
      [225, 255, 0],
      [174, 255, 0],
      [0, 255, 0],
    ]
    const busNum = [[min], [min + dif], [min + dif * 2], [min + dif * 3], [min + dif * 4], [min + dif * 5], [max]]
    const filter = item.filter((obj) => obj.layer == 'interconnection_summer')
    // console.log(filter)
    // console.log(filter.filter(obj => obj.id == 'interconnection_summer_230' )[0])

    filter
      .filter((obj) => obj.id == 'interconnection_summer_500')[0]
      .data.map((obj) => {
        if (obj.bus <= min) obj.specificDesign.color = colorScale[0]
        if (obj.bus > min && obj.bus <= busNum[1]) obj.specificDesign.color = colorScale[1]
        if (obj.bus > busNum[1] && obj.bus <= busNum[2]) obj.specificDesign.color = colorScale[2]
        if (obj.bus > busNum[2] && obj.bus <= busNum[3]) obj.specificDesign.color = colorScale[3]
        if (obj.bus > busNum[3] && obj.bus <= busNum[4]) obj.specificDesign.color = colorScale[4]
        if (obj.bus > busNum[4] && obj.bus <= busNum[5]) obj.specificDesign.color = colorScale[5]
        if (obj.bus >= busNum[5]) obj.specificDesign.color = colorScale[6]
      })
    filter
      .filter((obj) => obj.id == 'interconnection_summer_220-230')[0]
      .data.map((obj) => {
        if (obj.bus <= min) obj.specificDesign.color = colorScale[0]
        if (obj.bus > min && obj.bus <= busNum[1]) obj.specificDesign.color = colorScale[1]
        if (obj.bus > busNum[1] && obj.bus <= busNum[2]) obj.specificDesign.color = colorScale[2]
        if (obj.bus > busNum[2] && obj.bus <= busNum[3]) obj.specificDesign.color = colorScale[3]
        if (obj.bus > busNum[3] && obj.bus <= busNum[4]) obj.specificDesign.color = colorScale[4]
        if (obj.bus > busNum[4] && obj.bus <= busNum[5]) obj.specificDesign.color = colorScale[5]
        if (obj.bus >= busNum[5]) obj.specificDesign.color = colorScale[6]
      })
    filter
      .filter((obj) => obj.id == 'interconnection_summer_110-115')[0]
      .data.map((obj) => {
        if (obj.bus <= min) obj.specificDesign.color = colorScale[0]
        if (obj.bus > min && obj.bus <= busNum[1]) obj.specificDesign.color = colorScale[1]
        if (obj.bus > busNum[1] && obj.bus <= busNum[2]) obj.specificDesign.color = colorScale[2]
        if (obj.bus > busNum[2] && obj.bus <= busNum[3]) obj.specificDesign.color = colorScale[3]
        if (obj.bus > busNum[3] && obj.bus <= busNum[4]) obj.specificDesign.color = colorScale[4]
        if (obj.bus > busNum[4] && obj.bus <= busNum[5]) obj.specificDesign.color = colorScale[5]
        if (obj.bus >= busNum[5]) obj.specificDesign.color = colorScale[6]
      })

    item.find((obj) => obj.id === 'interconnection_summer_500').data = filter.filter(
      (obj) => obj.id == 'interconnection_summer_500',
    )[0].data
    item.find((obj) => obj.id === 'interconnection_summer_220-230').data = filter.filter(
      (obj) => obj.id == 'interconnection_summer_220-230',
    )[0].data
    item.find((obj) => obj.id === 'interconnection_summer_110-115').data = filter.filter(
      (obj) => obj.id == 'interconnection_summer_110-115',
    )[0].data

    item.find((obj) => obj.id === 'interconnection_summer_500').design.color = [255, 255, 255 * Math.random()]
    item.find((obj) => obj.id === 'interconnection_summer_220-230').design.color = [255, 255, 255 * Math.random()]
    item.find((obj) => obj.id === 'interconnection_summer_110-115').design.color = [255, 255, 255 * Math.random()]

    props.setLayerData(item)

    // let currentLayersInfoStoredJSON = JSON.parse(JSON.stringify(props.layerData))
    // let currentLayersInfo = [...currentLayersInfoStoredJSON]
    // dispatch( setLayersInfo( currentLayersInfo))
  }

  const showAllLayer = (name, season) => (event) => {
    // console.log("index: ", index, "\nname: ", name)
    const elems = document.getElementsByName(name)
    for (var i = 0; i < elems.length; i++) {
      if (!event.target.checked && elems[i].checked) elems[i].click()
      if (event.target.checked && !elems[i].checked) elems[i].click()
    }
  }

  const turnOff = (name) => {
    // console.log("index: ", index, "\nname: ", name)
    const btn = document.getElementById(name)
    const elems = document.getElementsByName(name)
    for (var i = 0; i < elems.length; i++) {
      if (btn.checked) btn.click()
      if (elems[i].checked) elems[i].click()
    }
  }

  const checkBoxInterconnection = (index, subIndex) => (event) => {
    let newArr = [...props.sidebarData]
    let newArr2 = [...props.layerData]
    let season = newArr[props.layer].layers[index].season.toLowerCase()

    // console.log("FIND: ", props.sidebarData[props.layer].layers[index][props.clientName][season][subIndex].id)
    // console.log(newArr2.find(
    //       (obj) => obj.id === props.sidebarData[props.layer].layers[index][props.clientName][season][subIndex].id,
    //     ))

    newArr[props.layer].layers[index][props.clientName][season][subIndex].label =
      newArr[props.layer].layers[index][props.clientName][season][subIndex].label
    newArr[props.layer].layers[index][props.clientName][season][subIndex].show = event.target.checked

    if (newArr[props.layer].layers[index].hasOwnProperty(props.clientName)) {
      if ('id' in newArr[props.layer].layers[index][props.clientName][season][subIndex]) {
        newArr2.find(
          (obj) => obj.id === props.sidebarData[props.layer].layers[index][props.clientName][season][subIndex].id,
        ).visible = event.target.checked
      } else {
        console.log(
          'NO TIENE ID EL ELEMENTO',
          '\nLayer:',
          newArr[props.layer].layers[index].name,
          '\nLABEL:',
          newArr[props.layer].layers[index][props.clientName][season][subIndex].label,
        )
      }
    } else {
      console.log('CAPA SIN MULTICAPAS')
    }
    props.setLayerData(newArr2)
    props.setSidebarData(newArr)

    // let currentLayersInfoStoredJSON = JSON.parse(JSON.stringify(props.layerData))
    // let currentLayersInfo = [...currentLayersInfoStoredJSON]
    // dispatch( setLayersInfo( currentLayersInfo))

    // let currentSidebarJSON = JSON.parse(JSON.stringify(props.sidebarData))
    // let currentSidebar = [...currentSidebarJSON]
    // dispatch( setSideBarInfo( currentSidebar ))
  }

  const changeSeason = (index, name) => (event) => {
    // console.log(name)
    let newArr = [...props.sidebarData]
    let currentSeason = props.sidebarData[props.layer].layers[index].season.toLowerCase()
    if (currentSeason !== 'summer') {
      turnOff(name)
      newArr[props.layer].layers[index].season = 'Summer'
      props.setSidebarData(newArr)

      let currentSidebarJSON = JSON.parse(JSON.stringify(props.sidebarData))
      let currentSidebar = [...currentSidebarJSON]
      dispatch(setSideBarInfo(currentSidebar))
    } else if (currentSeason !== 'winter') {
      turnOff(name)
      let newArr = [...props.sidebarData]
      newArr[props.layer].layers[index].season = 'Winter'
      props.setSidebarData(newArr)

      // let currentSidebarJSON = JSON.parse(JSON.stringify(props.sidebarData))
      // let currentSidebar = [...currentSidebarJSON]
      // dispatch( setSideBarInfo( currentSidebar ))
    }
  }

  const expand = (layer) => {
    let newArr = [...props.sidebarData]
    // console.log(layer)
    newArr.map((obj) => {
      const i = obj.layers.findIndex((x) => x.name === layer.name)
      if (obj.title === 'Interconnection Capacity' && i > -1) {
        if (obj.layers[i].style.height === '320px' && layer.name !== 'Transmission Lines Thermal Limits') {
          obj.layers[i].style = { height: '70px', trn: 'rotate(0deg)' }
        } else if (obj.layers[i].style.height === '300px' && layer.name === 'Transmission Lines Thermal Limits') {
          obj.layers[i].style = { height: '50px', trn: 'rotate(0deg)' }
        } else {
          obj.layers.map((val) => {
            if (val.name !== 'Transmission Lines Thermal Limits') val.style = { height: '70px', trn: 'rotate(0deg)' }
            if (val.name === 'Transmission Lines Thermal Limits') val.style = { height: '50px', trn: 'rotate(0deg)' }
          })
          if (layer.name === 'Transmission Lines Thermal Limits')
            obj.layers[i].style = { height: '300px', trn: 'rotate(90deg)' }
          if (layer.name !== 'Transmission Lines Thermal Limits')
            obj.layers[i].style = { height: '320px', trn: 'rotate(90deg)' }
        }
      }
      if (obj.title === 'Local Marginal Prices' && i > -1) {
        obj.layers.map((val) => {
          if (val.name === layer.name && val.style.height === '70px') {
            let height = val[props.clientName][Object.keys(val[props.clientName])[0]].length
            if (height !== 1) {
              height = 228 + height * 30 + 'px'
            } else {
              height = '228px'
            }
            val.style = { height: height, trn: 'rotate(90deg)' }
          } else if (val.name === layer.name && val.style.height !== '70px') {
            val.style = { height: '70px', trn: 'rotate(0deg)' }
          } else if (val.name !== layer.name) {
            val.style = { height: '70px', trn: 'rotate(0deg)' }
          }
        })
      }
    })
    props.setSidebarData(newArr)

    let currentSidebarJSON = JSON.parse(JSON.stringify(props.sidebarData))
    let currentSidebar = [...currentSidebarJSON]
    dispatch(setSideBarInfo(currentSidebar))
  }

  return (
    <Grow timeout={{ appear: 1000, enter: 1000, exit: 200 }} in={props.grow}>
      <div className="interconnection-mc">
        {props.modal != null ? (
          <Modal
            open={props.modal}
            onClose={() => props.closeModal()}
            // aria-labelledby="simple-modal-title"
            // aria-describedby="simple-modal-description"
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            <div className="info-modal">
              <InfoWindow closeModal={props.closeModal} data={props.infoWindow} />
            </div>
          </Modal>
        ) : null}
        {props.conLayers.map((layer, index) =>
          //props.clientName === 'demo colombia' || props.clientName === 'solarpack' ? (
          // props.country === 'Colombia' ? (
          //   <div />
          // ) :
          layer.season && layer.season.toLowerCase() === 'summer' ? (
            <div className="season-title-container" style={{ opacity: '1' }}>
              <p className="season-title">{props.country === 'Colombia' ? 'Propietary' : 'Summer'}</p>
              {props.country === 'Colombia' ? (
                <PowerIcon className="season-title-icon" style={{ color: '#d0cc2d' }} />
              ) : (
                <WbSunnyIcon className="season-title-icon" style={{ color: '#d0cc2d' }} />
              )}
            </div>
          ) : layer.season && layer.season.toLowerCase() === 'winter' ? (
            <div className="season-title-container" style={{ opacity: '1' }}>
              <p className="season-title" style={{ marginLeft: '58px' }}>
                {props.country === 'Colombia' ? 'MACC' : 'Winter'}
              </p>
              {props.country === 'Colombia' ? (
                <PowerIcon className="season-title-icon" style={{ color: '#002cff' }} />
              ) : (
                <AcUnitIcon className="season-title-icon" style={{ color: '#002cff' }} />
              )}
            </div>
          ) : (
            <div />
          ),
        )}

        <div className="ifr-title">
          <p className="ifr-title-txt" style={{ marginLeft: '6px' }}>
            {props.sidebarData[props.layer].title}
          </p>
          {props.modal != null ? (
            <Tooltip title={'Info'} placement="right-start" arrow>
              <InfoOutlinedIcon
                className="info-btn"
                onClick={() => props.showModal(props.sidebarData[props.layer], props.index)}
              />
            </Tooltip>
          ) : null}
        </div>
        <form className="form-container" action="">
          {props.conLayers.map((layer, index) => (
            <div className="plants-ifr" style={{ height: `${layer.style.height}`, overflow: 'hidden' }}>
              {
                //props.clientName === 'demo colombia' || props.clientName === 'solarpack' ? (
                // props.country === 'Colombia' ? (
                //   <div className="season-btn-container" style={{ background: '#2b2b2b26' }} />
                // ) :
                layer.season && layer.season.toLowerCase() === 'summer' ? (
                  <div className="season-btn-container">
                    <div
                      className="summer-btn"
                      style={{ background: '#d0cc2d' }}
                      onClick={changeSeason(index, layer.name)}
                    >
                      {props.country === 'Colombia' ? 'Propietary' : 'Summer'}
                    </div>
                    <div
                      className="winter-btn"
                      style={{ background: '#9d9d9d' }}
                      onClick={changeSeason(index, layer.name)}
                    >
                      {props.country === 'Colombia' ? 'MACC' : 'Winter'}
                    </div>
                  </div>
                ) : layer.season && layer.season.toLowerCase() === 'winter' ? (
                  <div className="season-btn-container">
                    <div
                      className="summer-btn"
                      style={{ background: '#9d9d9d' }}
                      onClick={changeSeason(index, layer.name)}
                    >
                      {props.country === 'Colombia' ? 'Propietary' : 'Summer'}
                    </div>
                    <div
                      className="winter-btn"
                      style={{ background: '#002cff' }}
                      onClick={changeSeason(index, layer.name)}
                    >
                      {props.country === 'Colombia' ? 'MACC' : 'Winter'}
                    </div>
                  </div>
                ) : (
                  <div />
                )
              }

              <div style={{ display: 'flex', height: '50px' }}>
                {props.clientName in layer ? (
                  <ArrowRightOutlinedIcon
                    style={{ transform: `${layer.style.trn}` }}
                    className="plants-arrow"
                    onClick={() => expand(layer)}
                  />
                ) : (
                  <div className="plants-no-arrow" />
                )}

                {
                  //props.clientName === 'demo colombia' || props.clientName === 'solarpack' ? (
                  props.country === 'Colombia' ? (
                    <label //name={layer.name}
                      className="ifr-lines-title"
                      onClick={() => expand(layer)}
                    >
                      {layer.name}
                    </label>
                  ) : 'season' in layer ? (
                    <label //name={layer.name}
                      className="ifr-lines-title"
                      onClick={() => expand(layer)}
                    >
                      {layer.name + layer.season}
                    </label>
                  ) : (
                    <label //name={layer.name}
                      className="ifr-lines-title"
                      onClick={() => expand(layer)}
                    >
                      {layer.name}
                    </label>
                  )
                }

                <FormControlLabel
                  style={{ marginRight: '-10px' }}
                  control={
                    <Checkbox
                      id={layer.name}
                      color="default"
                      onChange={showAllLayer(layer.name, layer.season)}
                      icon={<ToggleOffOutlinedIcon />}
                      checkedIcon={<ToggleOnOutlinedIcon style={{ color: '#a65e44' }} />}
                    />
                  }
                />
              </div>

              <div className="ifr-sub-menu">
                {props.clientName in layer
                  ? 'season' in layer
                    ? layer[props.clientName][layer.season.toLowerCase()].map((values, subIndex) => (
                        <div className="ifr-switch" key={values.value}>
                          <FormControlLabel
                            style={{ marginLeft: '15px', marginRight: '0px', alignSelf: 'center' }}
                            control={
                              <Checkbox
                                name={layer.name}
                                size="small"
                                color="primary"
                                icon={
                                  'img' in values ? (
                                    <img
                                      src={values.img}
                                      style={{
                                        width: '15px',
                                        height: '15px',
                                        filter: ' grayscale(100%)',
                                        marginTop: '0px',
                                      }}
                                    />
                                  ) : (
                                    <OfflineBoltIcon style={{ fontSize: '15px' }} />
                                  )
                                }
                                checkedIcon={
                                  'img' in values ? (
                                    <img src={values.img} style={{ width: '15px', height: '15px', marginTop: '0px' }} />
                                  ) : (
                                    <OfflineBoltIcon style={{ fontSize: '15px', color: values.color }} />
                                  )
                                }
                                onChange={checkBoxInterconnection(index, subIndex)}
                                value={values.value}
                              />
                            }
                          />
                          <label className="ifr-switch-label">{values.label}</label>
                        </div>
                      ))
                    : layer[props.clientName].map((values, subIndex) => (
                        <div className="ifr-switch" key={values.value}>
                          <FormControlLabel
                            style={{ marginLeft: '15px', marginRight: '0px', alignSelf: 'center' }}
                            control={
                              <Checkbox
                                name={layer.name}
                                size="small"
                                color="primary"
                                icon={
                                  'img' in values ? (
                                    <img
                                      src={values.img}
                                      style={{
                                        width: '15px',
                                        height: '15px',
                                        filter: ' grayscale(100%)',
                                        marginTop: '0px',
                                      }}
                                    />
                                  ) : (
                                    <OfflineBoltIcon style={{ fontSize: '15px' }} />
                                  )
                                }
                                checkedIcon={
                                  'img' in values ? (
                                    <img src={values.img} style={{ width: '15px', height: '15px', marginTop: '0px' }} />
                                  ) : (
                                    <OfflineBoltIcon style={{ fontSize: '15px', color: values.color }} />
                                  )
                                }
                                onChange={props.checkBox(index, subIndex)}
                                value={values.value}
                              />
                            }
                          />
                          <label className="ifr-switch-label">{values.label}</label>
                        </div>
                      ))
                  : null}

                {layer.name === 'Interconnection Capacity ' ? (
                  // props.clientName === 'demo colombia' || props.clientName === 'solarpack' ? (
                  // props.country === 'Colombia' ? (
                  //   <SeasonSlider
                  //     layer={layer}
                  //     classes={classes}
                  //     slider={sliderSummer}
                  //     sliderValue={sliderValueSummerCol}
                  //     setSliderValue={setSliderValueSummerCol}
                  //     heatmap={summerHeatmapCol}
                  //     max={1000}
                  //     resetMax={300}
                  //     onChangeAfter={() => summerHeatmapCol(sliderValueSummer[0], sliderValueSummer[1])}
                  //   />
                  // ) :
                  layer.season && layer.season.toLowerCase() === 'summer' ? (
                    <SeasonSlider
                      layers={layer[props.clientName].summer}
                      classes={classes}
                      slider={sliderSummer}
                      sliderValue={sliderValueSummer}
                      setSliderValue={setSliderValueSummer}
                      max={maxSliderValue}
                      resetMax={resetMax}
                      heatmap={generalHeatmap}
                      onChangeAfter={() =>
                        generalHeatmap(sliderValueSummer[0], sliderValueSummer[1], layer[props.clientName].summer)
                      }
                    />
                  ) : (
                    <SeasonSlider
                      layers={layer[props.clientName].winter}
                      classes={classes}
                      slider={sliderWinter}
                      sliderValue={sliderValueWinter}
                      setSliderValue={setSliderValueWinter}
                      max={maxSliderValue}
                      resetMax={resetMax}
                      heatmap={generalHeatmap}
                      onChangeAfter={() =>
                        generalHeatmap(sliderValueWinter[0], sliderValueWinter[1], layer[props.clientName].winter)
                      }
                    />
                  )
                ) : layer.name === 'Transmission Lines Thermal Limits' ? (
                  <div>
                    <label className="ifr-switch-label" style={{ marginLeft: '48px' }}>
                      Available Capacity
                    </label>
                    <div className="color-bar" />
                    <div className="color-legend">
                      <label style={{ fontSize: '12px', width: '60px' }}>{sliderValueLines[0]} MW</label>
                      <label style={{ fontSize: '12px', marginLeft: '60px' }}>{sliderValueLines[1]} MW+</label>
                    </div>
                    <ArrowDropDownIcon
                      style={{ visibility: 'visible', display: 'none' }}
                      className="drop-down-con"
                      onClick={() => {
                        // setHeatmap('hidden');
                        // setPlants({he:'335px',trn:'rotate(90deg)'})
                      }}
                    />
                    <label className="change-values-title">Heatmap Value</label>
                    <Slider
                      value={sliderValueLines}
                      className={classes.root}
                      onChange={sliderLines}
                      // onChangeCommitted={() => linesHeatmap(sliderValueLines[0], sliderValueLines[1])}
                      onChangeCommitted={() =>
                        generalHeatmap(sliderValueLines[0], sliderValueLines[1], layer[props.clientName])
                      }
                      max={3000}
                      valueLabelDisplay="auto"
                      aria-labelledby="range-slider"
                      style={{ marginTop: '5px' }}
                      id={layer.name}
                      // getAriaValueText={valuetext}
                    />
                    <div style={{ display: 'flex' }}>
                      <Button
                        style={{ margin: 'auto', height: '25px' }}
                        size="small"
                        variant="outlined"
                        className={classes.btn}
                        endIcon={<ReplayIcon />}
                        onClick={() => {
                          setSliderValueLines([0, 1000])
                          linesHeatmap(0, 1000)
                        }}
                      >
                        Reset
                      </Button>
                      <Button
                        style={{ marginLeft: '17px', height: '25px', display: 'none' }}
                        size="small"
                        variant="outlined"
                        onClick={() => linesHeatmap(sliderValueLines[0], sliderValueLines[1])}
                      >
                        Set
                      </Button>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          ))}
        </form>
      </div>
    </Grow>
  )
}

export default Interconnections
